<template>
  <div style="padding-bottom: 60px;">
    <div class="buyVip-content">
      <div class="buyVip-view" style="font-size: 20px;" v-if="vips.length>0">
        <div class="solid-left line-black padding-left-sm text-600">充会员</div>
        <div class="flex flex-wrap margin-top-xxl">
          <div v-for="(item,index) in vips" :key="index" class="vip-item-view">
            <div class="radius vip-item flex flex-direction align-center justify-between cursor"
                 :class="chooseVipsIdx==index?'active':''" @click="chooseVip(index)">
              <div style="margin-top: 50px;">
                <div class="flex align-center justify-center">
                  <div class="buyVip-icon margin-right-xs"></div>
                  {{item.name}}
                </div>
                <div class="flex align-end justify-center margin-top">
                  <div style="font-size: 30px;color: #ff6800;">
                    {{item.amount/100}}
                  </div>
                  <div class="margin-left text-xl margin-bottom-xs">元</div>
                </div>
              </div>
              <div class="solid-top padding-tb-sm text-center line-black"
                   :class="item.serviceKey=='onemonthvip'?'text-del':''"
                   style="width: 100%;">{{item.serviceKey=='onemonthvip'?('原价'+(item.originAmount/100)+'元'):item.remark}}</div>
              <div class="description" v-if="item.serviceKey!='onemonthvip'">限时折扣：{{item.description}}</div>
            </div>
            <div class="text-xl text-500 text-orange margin-bottom-xl text-center">一次性赠送{{MG(item.presentedDownloadTraffic,0)}}下载额度</div>
          </div>
        </div>
        <div class="flex align-center text-xl text-500 margin-right-xs" style="margin-top: 100px;">支付方式：
          <div class="wechat-pay-icon margin-right-sm"></div>
          <div class="text-400">微信支付</div>
        </div>
        <div class="flex align-center text-xl text-500 margin-right-xs" style="margin-top: 40px;">应付金额：
          <div style="font-size: 30px;color: #ff6800;">{{vips[chooseVipsIdx].amount/100}}元</div>
        </div>
        <div v-if="hasShowTrafficUser">
          <div class="flex align-center text-xl text-500 margin-right-xs" style="margin-top: 40px;">账号名称：
            <div style="font-size: 30px;">{{trafficUser.userName}}</div>
          </div>
          <div class="flex align-center text-lg text-400 margin-right-xs text-orange" style="margin-top: 40px;">
            当前活动属于以上账户，购买后为以上账号开通会员，请确认无误后购买；也可联系活动发起人购买
          </div>
        </div>
        <div class="flex align-center justify-end text-xl">
          <button class="cu-btn bg-green padding-tb-xl radius padding-lr-xxxl text-xxl text-500" @click="showPaycode">确定支付</button>
        </div>
      </div>

    </div>
    <div class="buyVip-content text-gray" style="margin-top: 50px; border-width: 0;background: none;">
      <div class="buyVip-view" style="padding: 0; ">
        <div>售前说明：</div>
        <div>1、会员版权益，<a href="https://docs.qq.com/sheet/DZEJXTXBIR0REVE5D?tab=fl8vmg&no_promotion=1" target="_blank">点击查看</a></div>
        <div>2、暂不支持支付宝付款；</div>
        <div>3、免费下载规则/免费权益可由平台根据实际运营情况进行优化调整；</div>
      </div>
    </div>
    <dialogCode ref="dialogCode"></dialogCode>
  </div>
</template>

<script>
  import App from '../util/comfun'
  import dialogCode from './components/checkout/dialogCode.vue'
  export default {
    data () {
      return {
        vips:[],
        chooseVipsIdx:0,
        trafficUser:{},
        hasShowTrafficUser:false,
      }
    },
    components:{
      dialogCode,
    },
    methods:{
      MG:App.MG,
      async getlist(){
        await this.getTrafficUser();
      
        this.activityId=this.$route.query.activityId
        this.activityName=this.$route.query.activityName
        App.demand('/activity/payment/queryPayServiceItemList','POST',{
          pageIndex: 1,
          pageSize: 100,
          //serviceKey: "posters",
          paymentType : "versionVip",
        }).then(res=>{
          this.vips=res.data.list;
          this.chooseVipsIdx=0;

        })
      },
      chooseVip(idx){
        this.chooseVipsIdx=idx;
      },
      showPaycode(){
        console.log('this.vips[this.chooseVipsIdx]',this.vips[this.chooseVipsIdx],this.trafficUser)
        this.$refs.dialogCode.show({
          amount:this.vips[this.chooseVipsIdx].amount,
          serviceKey:this.vips[this.chooseVipsIdx].serviceKey,
          activityId:this.activityId,
          trafficUser:this.trafficUser,
        })
      },
      async getTrafficUser(){
        let userId=wxlite.getStorageSync('userId')
        //console.error(userId)
        if(this.$route.query.userId) {
          userId = this.$route.query.userId;
        }
        App.demand('/user/info','GET',{
          userId:userId,
        }).then(res=>{
          this.trafficUser=res.data
          console.log('this.trafficUser',this.trafficUser)
          this.hasShowTrafficUser=userId!=this.trafficUser.id
        })
      },
    },
    mounted(){
      this.getlist();
      
    },

  }
</script>

<style>
  .buyVip-content{
    width: calc(100% - 40px);
    position: relative;
    margin: 0 auto;
    box-sizing: border-box;
    background-color: #fefefe;
    border: 1px solid #979797;
    border-radius: 2px;
  }
  .buyVip-view{
    max-width: 1160px;
    margin: 0 auto;
    padding: 40px 0 60px;
  }
  .vip-item-view{
    margin-right: 40px;
  }
  .vip-item{
    width: 260px;
    height: 200px;
    background: #ffffff;
    margin-bottom: 20px;
    box-sizing: border-box;
    padding-top: 0px;
    position: relative;
    border: 1px solid #979797;
  }
  .vip-item.active{
    border: 2px solid #ff6800;
  }
  .vip-item.active:before{
    width: 50px;
    height: 50px;
    border-bottom: 50px solid #ff6800;
    border-left: 50px solid transparent;
    position: absolute;
    right: 0;
    bottom: 0;
    content: "";
    z-index: 1;
    box-sizing: border-box;
  }
  .vip-item.active:after{
    position: absolute;
    right: 5px;
    bottom: 5px;
    content: "";
    z-index: 1;
    background-image: url("https://assets.pfotoo.com/pc/pay%20(4).png");
    background-size: 100% 100%;
    width: 23px;
    height: 17px;
  }
  .vip-item-view:nth-child(4n){
    margin-right: 0;
  }
  .description{
    position: absolute;
    top:0;
    left:0px;
    background: #ffefef;
    border-radius: 3px;
    font-size: 14px;
    font-family: PingFang, PingFang-SC;
    font-weight: SC;
    text-align: left;
    color: #ff6800;
    line-height: 20px;
    padding: 0px 10px;
  }
  .buyVip-icon{
    width: 18px;
    height: 17px;
    background-image: url("https://assets.pfotoo.com/pc/pay%20(2).png");
    background-size: 100% 100%;
  }
  .wechat-pay-icon{
    width: 30px;
    height: 26px;
    background-image: url("https://assets.pfotoo.com/pc/pay%20(1).png");
    background-size: 100% 100%;
  }
</style>


// WEBPACK FOOTER //
// src/pages/buyVip.vue